import { NetworkStatus, useQuery } from "@apollo/client";
import { useMemo } from "react";

import { AiProvider } from "types/generated";

import { GET_AVAILABLE_AI_PROVIDERS } from "./gql";

type UseAvailableAiProvidersReturn = {
  allProviders: AiProvider[];
  initialLoading: boolean;
  error: Error | undefined;
};

const useAvailableAiProviders = (provider?: string): UseAvailableAiProvidersReturn => {
  const { data, error, previousData, networkStatus } = useQuery(GET_AVAILABLE_AI_PROVIDERS, {
    variables: { provider: provider ?? null },
  });

  const allProviders = useMemo(() => {
    return data?.availableAIProviders || previousData?.availableAIProviders || [];
  }, [data, previousData]);

  return {
    allProviders,
    initialLoading: allProviders.length === 0 && networkStatus === NetworkStatus.loading,
    error,
  };
};

export default useAvailableAiProviders;
